<template>
<div v-if="!isPage('searchResult') && routeName()">
  <div class="commonHeader text_center">
    <img class="menuIcon" @click="checkNavStates" src="@/assets/images/menu.svg" alt="">
    <p>{{ isPage('serviceC')||isPage('favorite') ? '全部事项' : ( !isPage('appDetail') ? '一站式网上服务大厅' : '办理指南') }}</p>
    <img class="menuIcon" @click="toSearchPage" src="@/assets/images/search.svg" alt="">
  </div>
  <!-- if="isPage('apps') || isPage('todo') || isPage('doing') || isPage('meApply') || isPage('done') || isPage('flow_cc')" -->

  <common-app-nav v-if="isPage('serviceC') || isPage('favorite')" ></common-app-nav>

  <common-nav v-else-if="['todo','doing','meApply','flow_cc','done', 'apps'].includes(routeName())" ></common-nav>

</div>
  
</template>

<script>
import CommonNav from "../modules/CommonNav";
import CommonAppNav from "../modules/CommonAppNav";

export default {
  name: "commonHeader",
  inject: ['isPage', 'routeName'],
  components: {
    CommonNav,
    CommonAppNav
  },
  methods: {
    checkNavStates() {
      // this.$emit('checkNavStates')
      this.$store.commit('setShortcutVisible', true);
    },
    toSearchPage() {
      this.$router.push({name: 'searchResult'})
    }
  }
}
</script>

<style lang="less" scoped>
.commonHeader {
  // background-color: #518AF0;
  justify-content: space-between;
  padding: 12px 14px;

  p {
    color: white;
    font-size: 20px;
    letter-spacing: 0.1em;
    margin-bottom: 0;
  }

  .menuIcon {
    width: 22px;
    // height: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/layout/commonHeader.vue